<template>
  <div class="app">
    <audio id="bgsound" loop="loop"  autoplay>
      <source src="/assets/audio/bgsound4.mp3" type="audio/mpeg" />      
    </audio>
    <Loader :removeLoader="removeLoader"/>
    <Navigator ref="navigator"/>
      <transition
        mode="out-in"
        @leave="leave"
      >
        <div
          :class="[
            'app__container',
            `app__container--${$route.name}`
          ]"
          :key="$route.fullPath"
          v-if="loaderOut"
        >
          <router-view />
        </div>
    </transition>

    <transition name="fade">
      <AppModal v-show="showModal"/>
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

import Navigator from '@/components/Navigator.vue';
import Loader from '@/components/Loader.vue';
import AppModal from '@/components/AppModal.vue';
import raf from '@/scripts/raf';

export default {
  name: 'App',
  components: {
    Navigator,
    Loader,
    AppModal,
  },
  data() {
    return {
      loaderOut: false,
      showModal: false,
    };
  },
  mounted() {
    this.resize();
    raf.start();
    this.handleResize = debounce(() => this.resize(), 100);
    window.addEventListener('resize', this.handleResize);
    this.handleScroll = throttle(() => this.scroll(), 400);
    window.addEventListener('mousewheel', this.handleScroll);

    this.$eventHub.$on('showModal', () => {
      this.showModal = true;
    });
    this.$eventHub.$on('closeModal', () => {
      this.showModal = false;
    });     
    document.addEventListener("click", function(){
      let bgAudio = document.getElementById('bgsound');

      if(bgAudio.paused)
      {        
        bgAudio.play();  
        bgAudio.muted=false;          
      }
    });
  },
  methods: {
    leave(el, done) {
      this.$store.commit('SET_MENU', false);
      done();
    },
    resize() {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    scroll() {
      document.body.classList.toggle('body--fixed');
      this.playAudio();
    },
    removeLoader() {
      this.loaderOut = true;
      this.$refs.navigator.enter();
    },
    playAudio(){
      let bgAudio = document.getElementById('bgsound');

      if(bgAudio.paused)
      {        
        bgAudio.play();   
        bgAudio.muted=false;             
      }
      
      
    },
  },
};
</script>

<style lang="scss">
@import "./scss/base";

html,
body,
.app,
.app__container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}

body.body--fixed,
body.body--fixed .app,
body.body--fixed .app__container {
  position: fixed;
}

.app__container.app__container--how-we-work {
  position: fixed;
}

body.body--fixed .app__container.app__container--how-we-work {
  position: absolute;
}

.app__container {
  overflow: scroll;

  &.app__container--contact {
    -webkit-overflow-scrolling: touch;
  }
}

.section__line {
  width: 1px;
  height: 50px;
  margin: 45px 0;

  background-color: $color-white;
}

.c-hidden {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
